import "./index.css";
import { clsx } from "clsx";
import type { IFieldAccessory } from "./types";

export const FieldAccessory = ({
  size = "md",
  children,
  className,
}: IFieldAccessory) => {
  const rootClass = clsx(
    `nuco-field-accessory nuco-field-accessory--${size}`,
    className,
  );

  return <div className={rootClass}>{children}</div>;
};
